// Connection Status Indicator Component
// Shows Supabase connection status with visual indicator

import React, { useState, useEffect } from 'react';
import supabaseConnectionStatus from '../services/supabaseConnectionStatus';
import '../styles/ConnectionStatusIndicator.css';

const ConnectionStatusIndicator = ({ className = '' }) => {
  const [status, setStatus] = useState({
    status: 'checking',
    lastChecked: null,
    isConnected: false
  });

  useEffect(() => {
    // Initialize connection monitoring
    supabaseConnectionStatus.initialize();

    // Subscribe to status changes
    const unsubscribe = supabaseConnectionStatus.subscribe((newStatus) => {
      setStatus(newStatus);
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
      supabaseConnectionStatus.cleanup();
    };
  }, []);

  const getStatusConfig = () => {
    switch (status.status) {
      case 'connected':
        return {
          text: 'Connected',
          bgClass: 'status-connected',
          icon: '✓'
        };
      case 'disconnected':
        return {
          text: 'Disconnected',
          bgClass: 'status-disconnected',
          icon: '✗'
        };
      case 'checking':
        return {
          text: 'Checking...',
          bgClass: 'status-checking',
          icon: '⟳'
        };
      default:
        return {
          text: 'Unknown',
          bgClass: 'status-unknown',
          icon: '?'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`connection-status-indicator ${config.bgClass} ${className}`}>
      <span className="status-icon">{config.icon}</span>
      <span className="status-text">{config.text}</span>
      {status.status === 'connected' && status.lastChecked && (
        <span className="status-time">
          {new Date(status.lastChecked).toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </span>
      )}
    </div>
  );
};

export default ConnectionStatusIndicator;

